export const getters = {
    getPermissao: state => state.permissao,
    getPermissoes: state => state.permissoes,
    getModalCadastroPermissao: state => state.modalCadastrarPermissao,
    getModalExcluirPermissao: state => state.modalExcluirPermissao,
    getModalPesquisarPermissao: state => state.modalPesquisarPermissao
}

export default {}